import React from 'react';
import CourseRegistrationForm from './components/CourseRegistrationForm'; // Import the component

import './App.css';

function App() {
  return (
      <div className="App">
        <CourseRegistrationForm />
      </div>
  );
}

export default App;
